export const FETCH_MATERIALS_REQUEST = 'FETCH_MATERIALS_REQUEST';
export const FETCH_MATERIALS_SUCCESS = 'FETCH_MATERIALS_SUCCESS';
export const FETCH_MATERIALS_ERROR = 'FETCH_MATERIALS_ERROR';
